import { render, staticRenderFns } from "./ActivateCard.vue?vue&type=template&id=a2ad8a48&scoped=true&"
import script from "./ActivateCard.vue?vue&type=script&lang=js&"
export * from "./ActivateCard.vue?vue&type=script&lang=js&"
import style0 from "./ActivateCard.vue?vue&type=style&index=0&id=a2ad8a48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ad8a48",
  null
  
)

export default component.exports